import { BodyStats_Input } from "@/clients/models/BodyStats_Input";
import { BodyStatsService } from "@/clients/services/BodyStatsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateBodyStats = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.BODY_STATS],
    mutationFn: async (data: BodyStats_Input) => {
      const user = guardGetUserFromLocalStorage();
      await BodyStatsService.updateBodyStatsApiV1BodyStatsPut(user.id, data);
    },
    onSuccess: () => {
      // Weight/height recompute calories & macros on the backend.
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.CALORIE_BUDGET],
      });
    },
  });

  return {
    updateBodyStats: mutation.mutate,
    updateBodyStatsAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
